import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IonInfiniteScroll, ModalController} from '@ionic/angular';
import { GlobalService } from './../../../../config/services/global.service';

@Component({
    selector: 'app-modal-ccosto',
    templateUrl: './modal-ccosto.component.html',
    styleUrls: ['./modal-ccosto.component.scss'],
})
export class ModalCcostoComponent implements OnInit {
    @ViewChild('ccostoSearchBar')ccostoSearchBar;
    
    @Input() select: string;
    @Input() tipo: string;

    public ccostoList:any;
	  public loadCcosto:    boolean = true;
    public loadCcostoIni: boolean = false;
    public showSearch:    boolean = false;
    public from: any;
    public itemSelect = [];

  	constructor( 
  		private globalService: GlobalService,
  		private router: Router,
  		public  modalController: ModalController
  	) {
  		this.ccostoList = {list: [], page: 0, pages: 0, iTotal: 0, search: ''}
  	}

  	ngOnInit() {
  		if(this.globalService.selects.ccosto.length <= 0){
        	this.list('ini', null, 'Cargando...');
  		}else{
  			this.ccostoList.list = this.globalService.selects.ccosto;
  		}
        this.focusSearch();
  	}
    
    focusSearch() {
        setTimeout(() =>{
        	this.ccostoSearchBar.setFocus();
        },400);
    }

  	async list(from, ev, loadinSMS) {
  		const token       = await this.globalService.getToken();
        const entidad:any = await this.globalService.entidadDefault();

        this.ccostoList.page       = this.ccostoList.page+1;
        let params                 = {};
            params['take']         = 500;
            params['page']         = this.ccostoList.page;
            params['search']       = this.ccostoList.search;
            params['appID']        = this.globalService.appID;
            params['sedeID']       = entidad.sedeID;
            params['ccostoID']     = null;
        this.loadCcosto = true;
        this.globalService.requestPost('global/ccosto', params, 'jwt', token).subscribe(
            data => {
                if(data.validation == 'ok'){
                    let disabled = true;
                    if(data.list.length > 0){ 
                    	this.globalService.selects.ccosto = data.list;
                        this.ccostoList.list = data.list;
                        disabled = false;
                    }
                    this.loadCcosto    = false;
                    this.loadCcostoIni = true;
                    if(this.showSearch){
                    	this.focusSearch();
                    }
                }else{
                    this.globalService.failRequestHttp(data);
                }
            },
            error => {
                this.globalService.errorRequestHttp(error)
            }
        );
  	}

  	async ccostoSelect(item, ev) {
        if(this.select == 'single') {
            this.modalController.dismiss({
                'ccostoInfo': item
            });
        }else if(this.select == 'singleMultiple') {
            this.itemSelect.push(item);
            this.modalController.dismiss({
                'ccostoInfo': item
            });
        }
    }

  	async dismissModal(ev) {
        this.modalController.dismiss({
            'ccostoInfo': null
        })
    }
}



